<template>
  <div
      class="flex flex-wrap sm:gap-3 flex-col sm:flex-row justify-center space-y-2 sm:space-y-0 sm:justify-between w-full px-4 mb-2 mt-4 items-center">
    <select v-if="queriesToUpdate.criterion==='estado'"
            @change="(searchNew)=>updateQueries('search', searchNew.target.value)"
            :value="queriesToUpdate.search"
            class="w-full md:w-2/5 border border-gray-300 rounded-md text-gray-600 px-2 pl-2 pr-8 bg-white hover:border-gray-400 focus:outline-none text-xs focus:ring-0">
      <option value="" selected>Seleccione un estado...</option>
      <option value="activo">Activo</option>
      <option value="inactivo">Inactivo</option>
    </select>
    <select v-else-if="queriesToUpdate.criterion.split('.')[queriesToUpdate.criterion.split('.').length - 1]==='mes'"
            @change="(searchNew)=>updateQueries('search', searchNew.target.value)"
            :value="queriesToUpdate.search"
            class="w-full md:w-2/5 border border-gray-300 rounded-md text-gray-600 px-2 pl-2 pr-8 bg-white hover:border-gray-400 focus:outline-none text-xs focus:ring-0">
      <option value="" selected>Seleccione un mes...</option>
      <option v-for="(nameMonth, key, index) in nameMonths" :value="parseInt(key)+1" :key="index">{{ nameMonth }}
      </option>
    </select>
    <select v-else-if="queriesToUpdate.criterion==='tipo'"
            @change="(searchNew)=>updateQueries('search', searchNew.target.value)"
            :value="queriesToUpdate.search"
            class="w-full md:w-2/5 border border-gray-300 rounded-md text-gray-600 px-2 pl-2 pr-8 bg-white hover:border-gray-400 focus:outline-none text-xs focus:ring-0">
      <option value="" selected>Seleccione un tipo de movimiento...</option>
      <option value="ingreso">Ingreso</option>
      <option value="egreso">Egreso</option>
    </select>
    <select
        v-else-if="['obra_publica', 'beneficiarioContrato.contrato.obra_publica'].includes(queriesToUpdate.criterion)"
        @change="(searchNew)=>updateQueries('search', searchNew.target.value)"
        :value="queriesToUpdate.search"
        class="w-full md:w-2/5 border border-gray-300 rounded-md text-gray-600 px-2 pl-2 pr-8 bg-white hover:border-gray-400 focus:outline-none text-xs focus:ring-0">
      <option value="" selected>Seleccione la obra...</option>
      <option :value="1">Pública</option>
      <option :value="0">Privada</option>
    </select>
    <select v-else-if="queriesToUpdate.criterion === 'cap_adicionado'"
            @change="(searchNew)=>updateQueries('search', searchNew.target.value)"
            :value="queriesToUpdate.search"
            class="w-full md:w-2/5 border border-gray-300 rounded-md text-gray-600 px-2 pl-2 pr-8 bg-white hover:border-gray-400 focus:outline-none text-xs focus:ring-0">
      <option value="" selected>Seleccione una opción...</option>
      <option :value="1">Sí</option>
      <option :value="0">No</option>
    </select>
    <select v-else-if="'estado_provision' === queriesToUpdate.criterion"
            @change="(searchNew)=>updateQueries('search', searchNew.target.value)"
            :value="queriesToUpdate.search"
            class="w-full md:w-2/5 border border-gray-300 rounded-md text-gray-600 px-2 pl-2 pr-8 bg-white hover:border-gray-400 focus:outline-none text-xs focus:ring-0">
      <option value="" selected>Seleccione el estado de la provisión...</option>
      <option value="pendiente">PENDIENTE</option>
      <option value="cerrado">CERRADO</option>
    </select>
    <template v-else-if="'fecha' === queriesToUpdate.criterion">
      <DateRangePickerComponent
          @dateRangePicker="(newDateRangePicker)=> {this.dateRangePicker = newDateRangePicker;}"></DateRangePickerComponent>
    </template>
    <template v-else-if="'fecha_egreso' === queriesToUpdate.criterion">
      <DateRangePickerComponent
          @dateRangePicker="(newDateRangePicker)=> {this.dateRangePicker = newDateRangePicker;}"></DateRangePickerComponent>
    </template>
    <template v-else-if="'fecha_notificacion' === queriesToUpdate.criterion">
      <DateRangePickerComponent
          @dateRangePicker="(newDateRangePicker)=> {this.dateRangePicker = newDateRangePicker;}"></DateRangePickerComponent>
    </template>
    <template v-else-if="'created_at' === queriesToUpdate.criterion">
      <DateRangePickerComponent
          @dateRangePicker="(newDateRangePicker)=> {this.dateRangePicker = newDateRangePicker;}"></DateRangePickerComponent>
    </template>
    <template v-else-if="['rendimiento_periodo'].includes(queriesToUpdate.criterion)">
      <ValueRangePicker :custom-number-format="separateNumberByCommaInput" @valueRangePicker="(newValueRangePicker) => {this.valueRangePicker = newValueRangePicker}"></ValueRangePicker>
    </template>
    <div v-else class="flex bg-gray-100 w-full md:w-2/5 items-center rounded-lg">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mx-2" fill="none" viewBox="0 0 24 24"
           stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
      </svg>
      <input
          v-if="['rp', 'rubro.fuenteConcreta.codigo_fuente', 'beneficiarioContrato.contrato.codigo_contrato', 'beneficiarioContrato.beneficiario.nit', 'valor', 'reincorporado', 'liberado'].includes(queriesToUpdate.criterion)"
          type="number"
          id="cuenta_bancaria"
          @keyup="(searchNew)=>searchNumber(searchNew)"
          :value="queriesToUpdate.search"
          class="w-full bg-gray-100 outline-none border-transparent focus:border-transparent focus:ring-0 rounded-lg text-sm">
      <input v-else
             class="w-full bg-gray-100 outline-none border-transparent focus:border-transparent focus:ring-0 rounded-lg text-sm"
             :value="queriesToUpdate.search"
             type="text"
             @keyup="(searchNew)=>updateQueries('search', searchNew.target.value)"
             :disabled="!queriesToUpdate.criterion"
             :placeholder="queriesToUpdate.criterion?'Buscar...':'Seleccione un filtro...'"/>
    </div>
    <div class="flex flex-row flex-wrap sm:w-auto sm:space-x-2 items-center ">
      <select
          @change="(criterionNew)=>{updateQueries('criterion', criterionNew.target.value); this.dateRangePicker = undefined; this.valueRangePicker = undefined; updateQueries('search', '');updateQueries('where', '');}"
          :value="queriesToUpdate.criterion"
          class="w-full sm:w-auto border border-gray-300 rounded-md text-gray-600 px-2 pl-2 pr-8 bg-white hover:border-gray-400 focus:outline-none text-xs focus:ring-0">
        <option value="" selected>Filtrar por</option>
        <template v-for="(value, key, index) in tableColumns" :key='"A"+index'>
          <option :value="value['customCriterion']?value['customCriterion']:key" v-if="value.isFilter">
            {{ value.value }}
          </option>
        </template>
      </select>
      <select
          @change="(orderByNew)=>updateQueries('orderBy', orderByNew.target.value)"
          :value="queriesToUpdate.orderBy"
          class="w-full sm:w-auto mt-3 sm:m-auto border border-gray-300 rounded-md text-gray-600 px-2 pl-2 pr-8 bg-white hover:border-gray-400 focus:outline-none text-xs focus:ring-0">
        <option value="" selected>Ordenar por</option>
        <template v-for="(value, key, index) in tableColumns" :key='"B"+index'>
          <option :value="value['customCriterion']?value['customCriterion']:key" v-if="value.isOrder">
            {{ value.value }}
          </option>
        </template>
      </select>
      <button @click="orderAscDesc()" class="mt-3 sm:m-auto border border-gray-300 rounded-md text-gray-600 px-3 py-[9px] bg-white hover:border-gray-400 focus:outline-none text-xs
          focus:ring-0">
        <span>Ordenar {{ queriesToUpdate['order'] }}.</span>
      </button>
      <button @click="executeQueries()"
              class="mt-3 font-bold sm:m-auto border border-gray-300 hover:border-gray-400 px-3 py-[9px] text-white bg-green-500 hover:bg-green-600 rounded-md focus:outline-none text-xs focus:ring-0 flex flex-row items-center space-x-2">
        <span>BUSCAR</span>
        <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3" fill="none" viewBox="0 0 24 24"
             stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"/>
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
import {monthNames} from "@/common/constants/variables";
import {copiaProfunda} from "@/common/constants";
import DateRangePickerComponent from "@/layouts/DateRangePicker";
import { separateNumberByCommaInput } from "@/common/constants/functions";
import ValueRangePicker from "@/layouts/ValueRangePicker"

/**
 * Componente para filtrar una lista de elementos mediante una API.
 * @component FilterRefactComponent
 * @param {string} authToken - El token de autenticación para acceder a la API.
 * @param {Array} tableColumns - Las columnas de la tabla que se deben mostrar.
 * @param {Object} queries - Los filtros de búsqueda actuales.
 * @param {Object} queriesToUpdate - Los filtros de búsqueda actualizados.
 * @param {Object} nameMonths - Los nombres de los meses.
 * @param {Function} copiaProfunda - La función para hacer una copia profunda de un objeto.
 * @param {DateRangePickerComponent} dateRangePicker - El componente para seleccionar un rango de fechas.
 * @param {Object} valueRangePicker - componente para seleccionar un rango de valores.
 * @emits {Object} updateValues - Se emite cuando se actualizan los filtros de búsqueda.
 * @slot - Contenido del componente.
 */
export default {
  data: function () {
    return {
      nameMonths: Object.assign({}, monthNames),
      queriesToUpdate: {},
      copiaProfunda: copiaProfunda,
      dateRangePicker: undefined,
      valueRangePicker: undefined,
      separateNumberByCommaInput: separateNumberByCommaInput,
      console: console
    }
  },
  name: 'FilterRefactComponent',
  props: ['authToken', 'tableColumns', 'queries'],
  emits: ["updateValues"],
  components: {DateRangePickerComponent, ValueRangePicker},
  methods: {
    /**
     * Actualiza el filtro de ordenación y emite el evento updateValues.
     * @function
     * @memberof FilterRefactComponent
     */
    orderAscDesc() {
      this.updateQueries('order', this.queriesToUpdate['order'] === 'ASC' ? 'DESC' : 'ASC');
    },
    /**
     * Actualiza el filtro de búsqueda y emite el evento updateValues.
     * @function
     * @memberof FilterRefactComponent
     * @param {Object} searchNew - El evento de entrada de búsqueda.
     * @param {Object} searchNew.target - El elemento HTML que ha disparado el evento.
     */
    searchNumber(searchNew) {
      const value = parseInt(searchNew.target.value);
      this.updateQueries('search', !isNaN(value) ? value.toString() : '');
    },
    /**
     * Actualiza el filtro de búsqueda o de fechas.
     * @function
     * @memberof FilterRefactComponent
     * @param {string} key - La clave del filtro a actualizar.
     * @param {string} value - El valor del filtro a actualizar.
     */
    updateQueries(key, value) {
      this.queriesToUpdate[key] = value;
    },
    /**
     * Actualiza el filtro de fechas y emite el evento updateValues.
     * @function
     * @memberof FilterRefactComponent
     */
    useDateRangePicker() {
      let [dateStart, dateEnd] = this.dateRangePicker.getDates();
      dateStart = dateStart.toISOString().split('T')[0];
      dateEnd = dateEnd.toISOString().split('T')[0]

      let fecha;

      switch (this.queriesToUpdate.criterion) {
        case 'fecha_egreso':
          fecha =`fecha_egreso>='${dateStart}' and fecha_egreso<='${dateEnd}'` 
        break;
        case 'fecha_notificacion':
          fecha =`fecha_notificacion>='${dateStart}' and fecha_notificacion<='${dateEnd}'` 
        break;
        case 'created_at':
          dateStart += ' 00:00:00.0'
          dateEnd   += ' 23:59:59.0'
          fecha = `table.created_at>='${dateStart}' and table.created_at<='${dateEnd}'`
        break;
        default:
          fecha = `fecha>='${dateStart}' and fecha<='${dateEnd}'`
        break;
      }
      this.updateQueries('where',fecha);
    },
    /**
     Ejecuta las consultas de búsqueda.
     @function
     @name FilterRefactComponent#executeQueries
     @emits {updateValues} - Evento que emite los valores actualizados de las consultas.
     */
     executeQueries() {
      let dateRangePicker2 = false;

      if (['fecha_egreso', 'created_at', 'fecha_notificacion'].includes(this.queriesToUpdate.criterion)) {
        dateRangePicker2 = true;
      } else if ('fecha' !== this.queriesToUpdate.criterion) {
        this.dateRangePicker = undefined;
      }

      if (this.dateRangePicker || dateRangePicker2) this.useDateRangePicker();

      if (this.valueRangePicker && (this.valueRangePicker.startValue || this.valueRangePicker.endValue)) {
        this.updateQueries(
          'where', 
          'table.' + this.queriesToUpdate.criterion + '>=' + this.valueRangePicker.startValue + ' and ' +
          'table.' + this.queriesToUpdate.criterion + '<=' + this.valueRangePicker.endValue
        );
      } else {
        this.updateQueries('where', this.queries.where ? this.queries.where : '');
      }
        //si algo se totea en los filtros es por culpa de esto, antes estaba asi
        //this.updateQueries('where','');
        this.$emit('updateValues', {'queries': copiaProfunda(this.queriesToUpdate)});
    }
  },
  created() {
    this.queriesToUpdate = this.copiaProfunda(this.queries);
  }
}
</script>